import { getEnv, IStateTreeNode } from "mobx-state-tree"
import { Environment } from "../environment"
import { createAxios } from "../../utils/axios"
import { AxiosRequestConfig } from "apisauce/node_modules/axios"
import { ApiResponse, CancelToken } from "apisauce"
import { Toast } from "native-base"

/**
 * Adds a environment property to the node for accessing our
 * Environment in strongly typed.
 */
export const withEnvironment = (self: IStateTreeNode) => ({
  views: {
    /**
     * The environment.
     */
    get environment() {
      return getEnv<Environment>(self)
    },
    get apiSauce() {
      const apisauce = this.environment.api.apisauce;
      const notifyNetworkError = (response: ApiResponse<any>) => {
        if (response.problem === "CANCEL_ERROR" && !Toast.isActive('CanceledError'))
          Toast.show({ id: 'CanceledError', title: 'Request Timeout' })
        return response;
      }
      let timeoutId = null;
      const clearCancelTimeout = () => clearTimeout(timeoutId);
      return {
        get: function(url: string, params?: any, axiosConfig?: AxiosRequestConfig) {
          return apisauce.get(url, params, {
            cancelToken: new CancelToken(function (cancel) {
              timeoutId = setTimeout(() => cancel('Request Timeout'), 10000)
            }),
            ...axiosConfig
          }).then(notifyNetworkError).finally(clearCancelTimeout)
        },
        post: function(url: string, data?: any, axiosConfig?: AxiosRequestConfig) {
          return apisauce.post(url, data, {
            cancelToken: new CancelToken(function (cancel) {
              timeoutId = setTimeout(() => cancel('Request Timeout'), 15000)
            }),
            ...axiosConfig
          }).then(notifyNetworkError).finally(clearCancelTimeout)
        },
        put: function(url: string, data?: any, axiosConfig?: AxiosRequestConfig) {
          return apisauce.put(url, data, {
            cancelToken: new CancelToken(function (cancel) {
              timeoutId = setTimeout(() => cancel('Request Timeout'), 15000)
            }),
            ...axiosConfig
          }).then(notifyNetworkError).finally(clearCancelTimeout)
        },
        delete: function(url: string, params?: any, axiosConfig?: AxiosRequestConfig) {
          return apisauce.delete(url, params, {
            cancelToken: new CancelToken(function (cancel) {
              timeoutId = setTimeout(() => cancel('Request Timeout'), 15000)
            }),
            ...axiosConfig
          }).then(notifyNetworkError).finally(clearCancelTimeout)
        }
      }
    },
    get axios() {
      return createAxios()
    }
  },
})
